import { ErrorWithViolations as e } from "./error-with-violations.mjs";
import { ErrorWithFields as t } from "./error-with-fields.mjs";
//#region src/errors/bad-request.ts
var n = class extends t {
	toErrorWithViolations() {
		return super.toErrorWithViolations({
			type: "",
			status: r.code,
			title: "",
			code: r.code
		});
	}
}, r = class extends e {
	static code = 422;
};
//#endregion
export { n as BadRequest, r as BadRequestWithViolations };
